/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import Brochures from '../components/Brochures/Brochures';
import Preview from '../components/Preview/Preview';
import { hot } from "react-hot-loader";
import {IS_PROD} from "../libs";

class App extends React.Component {
  render() {
    return (
      <div>
        <BrowserRouter basename={IS_PROD ? '/model-range' : undefined}>
          <Switch>
            <Route exact path="/:id" component={Preview} />
            <Route exact path="/:id/:type" component={Preview} />
            <Route component={Brochures} />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.element,
  carList: PropTypes.array,
};

export default hot(module)(App);





// WEBPACK FOOTER //
// ./src/components/App.js